export default __webpack_public_path__ + "static/media/enchantedForest.ae665ec0.png";